import React from 'react';
import { Route as ReactRoute, Redirect, Switch } from '@okapi/router-react';
import { memo } from 'common/hocs/memo';
import { patchPath } from 'utils/patch-path';
import { Route, routes } from './routes';
import { useStoreContext } from '../store';

export const Routes = memo(() => <NestedRoutes routesTree={routes} />);

export const NestedRoutes: React.FC<{ routesTree: Route[] | undefined }> = ({ routesTree }) => {
  const store = useStoreContext();
  const { model, catalogue } = store;

  if (model?.error || catalogue?.error) {
    return <Redirect to="/500" />;
  }

  return (
    <Switch>
      {routesTree?.map(({ routes: nestedRoutes, component: Component, path, key, strict, exact }) => (
        <ReactRoute path={patchPath(path)} key={key} strict={strict} exact={exact}>
          {Component ? (
            <Component>
              <NestedRoutes routesTree={nestedRoutes} />
            </Component>
          ) : (
            <NestedRoutes routesTree={nestedRoutes} />
          )}
        </ReactRoute>
      ))}
    </Switch>
  );
};
